import React, { useEffect } from 'react'
import CreditCardContainer from '../containers/CreditCard'
import Nav from '../components/nav/Nav';

const CreditCard: React.FC= () => {


  useEffect(() => {
    document.title = 'Elite Community CU | Credit Cards';

    const metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    metaDescription.content = "Loan Application Apply For Credit CardApply Online from Anywhere eZCardInfo eZCardInfoAccess Your Credit Card Easily VISA Account Types The Visa Classic Card has a ...";
    document.head.appendChild(metaDescription);
  }, []);

  return (
    <div>
      <Nav />
      <CreditCardContainer />
    </div>
  )
}

export default CreditCard